import { Datetime, newDate } from 'domain/dateFormat';

export type ErrorLog = {
  id: number;
  product: string;
  function: string;
  requestId: string;
  url: string;
  level: number;
  code: string;
  description: string;
  occurredAt: string;
  customerDomain: string;
  customerName: string;
};

export const defaultErrorLog: ErrorLog = {
  id: 0,
  product: '',
  function: '',
  requestId: '',
  url: '',
  level: 0,
  code: '',
  description: '',
  occurredAt: '',
  customerDomain: '',
  customerName: '',
};

export type SearchCondition = {
  match: string;
  product: string;
  level: number;
  customerDomain: string;
  occurredAtStart: string;
  occurredAtEnd: string;
  limit: number;
  offset: number;
};

export const defaultSearchCondition: SearchCondition = {
  match: '',
  product: '',
  level: 0,
  customerDomain: '',
  occurredAtStart: newDate().toISOString(),
  occurredAtEnd: newDate().toISOString(),
  limit: 50,
  offset: 0,
};

/**
 * Postログの詳細検索フィールド
 */
export const advancedSearchFields = [
  {
    input: 'TextField',
    id: 'product',
    label: 'Product',
    type: 'text',
  },
  {
    input: 'TextField',
    id: 'level',
    label: 'Level',
    type: 'text',
  },
  {
    input: 'TextField',
    id: 'customerDomain',
    label: 'CustomerDomain',
    type: 'text',
  },
];

/**
 * 画面上で変更されたら、検索条件オブジェクトを更新する
 */
export const changeSearchCondition = (
  cond: SearchCondition,
  key: keyof SearchCondition,
  value: string | number | Datetime
): SearchCondition => {
  switch (key) {
    case 'match':
      return { ...cond, match: value as string };
    case 'product':
      return { ...cond, product: value as string };
    case 'level':
      return { ...cond, level: parseInt(value as string) };
    case 'customerDomain':
      return { ...cond, customerDomain: value as string };
    case 'occurredAtStart':
      return { ...cond, occurredAtStart: (value as Datetime).toISOString() };
    case 'occurredAtEnd':
      return { ...cond, occurredAtEnd: (value as Datetime).toISOString() };
    case 'limit':
      return { ...cond, limit: value as number };
    case 'offset':
      return { ...cond, offset: value as number };
  }
};
